var global = require('../internals/global');

var isCallable = require('../internals/is-callable');

var inspectSource = require('../internals/inspect-source');

var WeakMap = global.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));